import React from "react";
import { ArrowLeft, FileImage, PenTool, Shapes, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

import BrandStudioShell from "@/components/brandStudio/BrandStudioShell";
import BrandStudioSignature from "@/components/brandStudio/BrandStudioSignature";
import { BRAND_STUDIO_ROUTES } from "@/lib/brandJourney.mjs";

const WORKSHOP_DIRECTIONS = Object.freeze([
  { title: "Новый логотип", Icon: PenTool },
  { title: "Монограмма", Icon: Sparkles },
  { title: "Дополнительный знак", Icon: Shapes },
  { title: "Новый вариант", Icon: FileImage },
]);

export default function MOLogoWorkshop() {
  const nav = useNavigate();

  return (
    <BrandStudioShell title="Мастерская логотипов">
      <main className="w-full max-w-5xl min-w-0 overflow-x-clip pb-16" data-testid="logo-workshop">
        <button type="button" onClick={() => nav(BRAND_STUDIO_ROUTES.home)} className="mb-7 inline-flex min-h-11 items-center gap-1.5 rounded-xl border border-[#D9C39F] bg-[#FFFDF8] px-3 text-[12.5px] text-[#4A3728]">
          <ArrowLeft size={14} /> Вернуться в Brand Studio
        </button>
        <header className="max-w-3xl">
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-[#8B6F4B]">Отдельная мастерская</div>
          <h1 className="mt-2 text-[39px] leading-[0.98] text-[#2A1D14] md:text-[55px]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Логотипы</h1>
          <p className="mt-4 max-w-2xl text-[14px] leading-relaxed text-[#5B4326]">Пространство для создания новых логотипов, монограмм, дополнительных знаков и вариантов. Утверждённая система бренда остаётся отдельно в Визуальной ДНК.</p>
        </header>
        <section className="mt-7 rounded-2xl border border-[#E4D5C0] bg-[#FFFDF8] p-5 sm:p-7" data-testid="logo-workshop-foundation">
          <span className="inline-flex rounded-full border border-[#DED2BF] px-3 py-1.5 text-[10px] uppercase tracking-[0.1em] text-[#806B52]">Основа мастерской</span>
          <h2 className="mt-5 text-[27px] text-[#2A1D14]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Новое пространство готовится</h2>
          <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-[#6D5842]">Здесь появится самостоятельный процесс создания. Текущая Logo Family Version 1, её reasoning, approval и история не изменяются.</p>
          <div className="mt-6 grid min-w-0 grid-cols-2 gap-3 sm:grid-cols-4">
            {WORKSHOP_DIRECTIONS.map(({ title, Icon }) => (
              <div key={title} className="min-w-0 rounded-xl border border-[#E8DCCA] bg-[#FBF6ED] p-3.5">
                <span className="grid h-9 w-9 place-items-center rounded-full bg-[#F1E5D1] text-[#7A6247]" aria-hidden="true"><Icon size={16} /></span>
                <div className="mt-3 break-words text-[13px] leading-tight text-[#2A1D14]">{title}</div>
              </div>
            ))}
          </div>
        </section>
        <footer className="pt-10"><BrandStudioSignature /></footer>
      </main>
    </BrandStudioShell>
  );
}
